import { styles } from "../../styles";
import { useAuth, adminSignOut } from "../../hooks/useAuth";
import { AdminLogin } from "./AdminLogin";
import { HoursCard } from "./HoursCard";
import { BreedsCard } from "./BreedsCard";
import { HolidaysCard } from "./HolidaysCard";
import { MessageCard } from "./MessageCard";
import { BrandingCard } from "./BrandingCard";
import { SettingsCard } from "./SettingsCard";
import { TeamCard } from "./TeamCard";
import { ActivityCard } from "./ActivityCard";

export function Admin() {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return <div style={styles.spinnerWrap} role="status" aria-live="polite">Checking your access&hellip;</div>;
  }

  if (!user) return <AdminLogin />;

  // Signed in but not on the admin allowlist.
  if (!isAdmin) {
    return (
      <div style={styles.authWrap} className="fade">
        <div style={styles.authCard}>
          <h1 style={{ ...styles.cardTitle, fontSize: 24 }}>Not authorized</h1>
          <p style={styles.sub}>
            You're signed in as {user.email}, but this account isn't set up for shop admin.
            Ask the owner to grant access, then sign in again.
          </p>
          <button className="ghost" style={styles.ghost} onClick={() => void adminSignOut()}>Sign out</button>
        </div>
      </div>
    );
  }

  return (
    <div className="fade">
      <section style={styles.heroWrap}>
        <p style={styles.eyebrow}>Admin</p>
        <h1 style={styles.h1}>Run the shop's calendar.</h1>
        <p style={styles.lede}>Set hours, breeds, holidays, branding, and the note customers see when they book.</p>
      </section>

      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16, gap: 12, alignItems: "center" }}>
        <span style={{ fontSize: 14, color: "var(--muted)", margin: 0 }}>{user.email}</span>
        <button className="ghost" style={styles.ghostSm} onClick={() => void adminSignOut()}>Sign out</button>
      </div>

      <div className="admingrid" style={styles.adminGrid}>
        <div style={styles.adminLeft}>
          <HoursCard />
          <BreedsCard />
        </div>
        <div style={styles.adminRight}>
          <BrandingCard />
          <MessageCard />
          <HolidaysCard />
          <SettingsCard />
          <TeamCard />
          <ActivityCard />
        </div>
      </div>
    </div>
  );
}
